import "./MainContractorsDevelopers.module.css";
import Header from "@/reusable_sections/Header";
import ContractorOverview from "./sections/ContractorOverview";
import Relationship from "./sections/Relationship";
import Footer from "@/reusable_sections/Footer";
export default function MainContractorsDevelopersPage() {
  return <div>
      <Header />
      <ContractorOverview />
      <Relationship />
      <Footer />
    </div>;
}